import styled from 'styled-components';
import Utility from '../../../../../util/utilityfunctions';

export default styled.section`
	display: flex;
	flex-flow: column;
	align-items: flex-end;
	font-size: 1.4rem;
	& .export-variant {
		font-size: 1.2rem;
		color: ${({theme}) => theme.color[`blue600yellow400`]};
	}
	.export-btn-wrap {
		display: flex;
		justify-content: flex-end;
		padding-top: 1rem;
		height: 4.1rem;
	}
`;
